import React, { useContext } from "react";
import { useSelector } from "react-redux";
import classNames from "classnames";
import { Link, withRouter } from "react-router-dom";
import { makeStyles } from "@material-ui/styles";
import Drawer from "@material-ui/core/Drawer";
import IconButton from "@material-ui/core/IconButton";
import Divider from "@material-ui/core/Divider";
import Badge from "@material-ui/core/Badge";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import HomeIcon from "@material-ui/icons/Home";
import WeekscheduleIcon from "@material-ui/icons/Event";
import BookingsIcon from "@material-ui/icons/AccountCircle";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import { AppContext, TOGGLE_MENU, CLOSE_MENU } from "../Context";
import CoursesIcon from "../Images/CoursesIcon";

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  drawer: { "@media(max-width: 600px)": { display: "none" } },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: "hidden",
  },
  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: 0,
    [theme.breakpoints.up("sm")]: {
      width: "72px",
    },
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: "0 8px",
    ...theme.mixins.toolbar,
  },
  chevron: {
    color: theme.app.labelColor,
  },
  primary: {
    whiteSpace: "nowrap",
  },
  active: {
    height: "100%",
    color: theme.palette.primary.main,
    pointerEvents: "none",
  },
  activeColor: {
    "& div": {
      color: theme.palette.primary.main,
    },
    "& svg g": {
      color: theme.palette.primary.main,
      fill: theme.palette.primary.main,
    },
  },
  inactive: {
    height: "100%",
    color: theme.app.labelColor,
  },
  inactiveColor: {
    "& div": {
      color: theme.app.labelColor,
    },
    "& svg g": {
      color: theme.app.labelColor,
      fill: theme.app.labelColor,
    },
  },
  activeBorder: {
    position: "absolute",
    left: "0rem",
    borderLeft: `6px solid ${theme.palette.primary.main}`,
    height: "100%",
  },
  unpaid: {
    backgroundColor: theme.app.dangerColor,
    color: "white",
  },
  paid: {
    backgroundColor: theme.app.infoColor,
    color: "white",
  },
  coursesIcon: {
    width: "20px",
    height: "auto",
  },
}));

const Menu = (props) => {
  const { location, mybookings } = props;
  const classes = useStyles();
  const context = useContext(AppContext);
  const { dispatch, state } = context;
  const { menuOpen } = state;
  const { language, auth } = useSelector((state) => ({
    language: state.language,
    auth: state.oidc.user !== null && !state.oidc.user.expired,
  }));
  const toggleMenu = () => dispatch({ type: TOGGLE_MENU });
  const closeMenu = () => dispatch({ type: CLOSE_MENU });
  const handleNavigate = () => {
    if (window.innerWidth < 1024) {
      closeMenu();
    }
  };
  const confirmed = mybookings.filter((b) => b.isConfirmed).length;
  const anyUnpaid = mybookings.some((b) => !b.isPaid && b.isConfirmed);
  return (
    <Drawer
      variant="permanent"
      className={classNames(classes.drawer, {
        [classes.drawerOpen]: menuOpen,
        [classes.drawerClose]: !menuOpen,
      })}
      classes={{
        paper: classNames({
          [classes.drawerOpen]: menuOpen,
          [classes.drawerClose]: !menuOpen,
        }),
      }}
      open={menuOpen}
    >
      <div className={classes.toolbar}>
        <IconButton onClick={toggleMenu} aria-label={language.toggleMenu}>
          <ChevronLeftIcon className={classes.chevron} />
        </IconButton>
      </div>
      <Divider />
      <List>
        <li
          className={
            location.pathname === "/"
              ? classes.activeColor + " activeColor"
              : classes.inactiveColor
          }
        >
          <ListItem
            onClick={handleNavigate}
            component={Link}
            to="/"
            button
            aria-label={language.home}
          >
            <div
              className={
                location.pathname === "/"
                  ? classes.activeBorder + " activeBorder"
                  : undefined
              }
            />
            <ListItemIcon>
              <HomeIcon />
            </ListItemIcon>
            <ListItemText primary={language.home} />
          </ListItem>
        </li>
        <li
          className={
            location.pathname === "/courses"
              ? classes.activeColor + " activeColor"
              : classes.inactiveColor
          }
        >
          <ListItem
            onClick={handleNavigate}
            component={Link}
            to="/courses"
            button
            aria-label={language.courses}
          >
            <div
              className={
                location.pathname === "/courses"
                  ? classes.activeBorder + " activeBorder"
                  : classes.inactive
              }
            />
            <ListItemIcon>
              <CoursesIcon />
            </ListItemIcon>
            <ListItemText primary={language.courses} />
          </ListItem>
        </li>
        <li
          className={
            location.pathname.startsWith("/week")
              ? classes.activeColor + " activeColor"
              : classes.inactiveColor
          }
        >
          <ListItem
            onClick={handleNavigate}
            component={Link}
            to="/week"
            button
            aria-label={language.week_schedule}
          >
            <div
              className={
                location.pathname === "/week"
                  ? classes.activeBorder + " activeBorder"
                  : undefined
              }
            />
            <ListItemIcon>
              <WeekscheduleIcon />
            </ListItemIcon>
            <ListItemText
              primary={language.week_schedule}
              classes={{ primary: classes.primary }}
            />
          </ListItem>
        </li>

        {auth && (
          <li
            className={
              location.pathname === "/bookings"
                ? classes.activeColor + " activeColor"
                : classes.inactiveColor
            }
          >
            <ListItem
              onClick={handleNavigate}
              component={Link}
              to="/bookings"
              button
              aria-label={language.my_bookings}
            >
              <div
                className={
                  location.pathname === "/bookings"
                    ? classes.activeBorder + " activeBorder"
                    : undefined
                }
              />
              <ListItemIcon>
                {confirmed ? (
                  <Badge
                    badgeContent={confirmed}
                    classes={{
                      badge: anyUnpaid ? classes.unpaid : classes.paid,
                    }}
                  >
                    <BookingsIcon className={classes.buttonIcon} />
                  </Badge>
                ) : (
                  <BookingsIcon className={classes.buttonIcon} />
                )}
              </ListItemIcon>
              <ListItemText
                primary={language.my_bookings}
                classes={{ primary: classes.primary }}
              />
            </ListItem>
          </li>
        )}
      </List>
    </Drawer>
  );
};

export default withRouter(Menu);
